import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { useLoaderData } from "react-router";
import FreeFieldProfileOptionsPanel from "./FreeFieldProfileOptionsPanel";
import FreeFieldProfileDetailSection from "./FreeFieldProfileDetailSection";

const FreeFieldProfileDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.FreeFieldProfileDetailFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <FreeFieldProfileDetailSection
        freeFieldProfile={viewModel.freeFieldProfile}
        freeFieldsForProduction={viewModel.freeFieldsForProduction}
        freeFieldsForShow={viewModel.freeFieldsForShow}
        userToClients={viewModel.userToClients}
        listUrl={viewModel.listUrl}
      />
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn>
      <FreeFieldProfileOptionsPanel
        optionsPanelData={viewModel.optionsPanel}
        listUrl={viewModel.listUrl}
        freeFieldProfileId={viewModel.freeFieldProfile.freeFieldProfileId}
        environment={viewModel.freeFieldProfile.environment}
      />
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>
}

export default FreeFieldProfileDetailApp;